// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* MyCalendar.css */\n.highlight {\n  background-color: #ffcc00; /* Highlight color */\n  border-radius: 50%; /* Optional: make it circular */\n}", ""]);
// Exports
module.exports = exports;
